import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddNoticeboardLayer from "../components/AddNoticeboardLayer";
 
 
const AddNoticeboardPage = () => {
  return (
    <>
     
 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Noticeboard  </h5><Breadcrumb title="Add Noticeboard" /></div>
 
        {/* CalendarMainLayer */}
        <AddNoticeboardLayer />
 
 
    </>
  );
};
 
export default AddNoticeboardPage;
 
 